const storedUser = JSON.parse(localStorage.getItem("user")) || {};
//console.log("storedUser",storedUser)
const navemail = localStorage.getItem("navemail")|| {};
//console.log("navemail",navemail)
const generateMenu = () => {
  const baseMenu = [
    {
      path: "dashboard",
      icon: "fa fa-sitemap",
      title: "Tableau de bord",
      children: [{ path: "/dashboard/v1", title: "Graphiques" },
                 { path: "/dashboard/projet", title: "D’atteinte des résultats " },
                 { path: '/map/google', title: 'Google Map' } ],
    }
  ];

  if (storedUser?.email === navemail) {
    baseMenu.push({
      path: '/ResultReport',
      icon: 'fa fa-map',
      title: 'Résultats du Projet',
      children: [
        {
          path: '/ResultReport/rapport',
          title: 'Rapport',
        },
      ],
    });
  }

  if (storedUser?.usertype === 1) {
    return [
      ...baseMenu,
      {
        path: "Data",
        icon: "fa fa-microchip",
        title: "Saisie de la progression",
        children: [{ path: "/Data/dataentry", title: "Collecte de données" }, 
        { path: "/Data/dataedit", title: "Liste des données" }],
      },
      {
        path: "Raportee",
        icon: "fa fa-microchip",
        title: "Rapports",
        children: [          
            { path: "/Raportee/interne", title: "Internes" },
          { path: "/Raportee/externe", title: "Externes" }],
      },
      {
        path: "predefinedreports",
        icon: "fa fa-microchip",
        title: "Rapports prédéfinis",
        children: [{ path: "/predefinedreports/predefined", title: "Liste des rapports" }],
      },
      {
        path: "Administration",
        icon: "fa fa-microchip",
        title: "Administration",
        children: [{ path: "/Administration/usermanage", title: "Gérer les utilisateurs" }],
      },
    ];
  } else if (storedUser?.usertype === 2) {
    return [
      ...baseMenu,
      {
        path: "Data",
        icon: "fa fa-microchip",
        title: "Saisie de la progression",
        children: [{ path: "/Data/dataentry", title: "Collecte de données" }, 
        { path: "/Data/dataedit", title: "Liste des données" }],
      },
      {
        path: "Raportee",
        icon: "fa fa-microchip",
        title: "Rapports",
        children: [
          { path: "Raportee",title: "Internes",  children: [
            { path: "/Raportee/interne", title: "Niveau central" },
            {path: "/Raportee/interneregional", title: "Niveau régional" }]},
          { path: "/Raportee/externe", title: "Externes" }],
      },
      {
        path: "predefinedreports",
        icon: "fa fa-microchip",
        title: "Rapports prédéfinis",
        children: [{ path: "/predefinedreports/predefined", title: "Liste des rapports" }],
      }
    ];
  }
  else if (storedUser?.usertype === 3) {
    return [
      ...baseMenu,
      {
        path: "Data",
        icon: "fa fa-microchip",
        title: "Saisie de la progression",
        children: [ 
        { path: "/Data/dataedit", title: "Liste des données" }],
      },
      {
        path: "Raportee",
        icon: "fa fa-microchip",
        title: "Rapports",
        children: [
          { path: "Raportee",title: "Internes",  children: [
            { path: "/Raportee/interne", title: "Niveau central" },
            {path: "/Raportee/interneregional", title: "Niveau régional" }]},
          { path: "/Raportee/externe", title: "Externes" }],
      },
      {
        path: "predefinedreports",
        icon: "fa fa-microchip",
        title: "Rapports prédéfinis",
        children: [{ path: "/predefinedreports/predefined", title: "Liste des rapports" }],
      }
    ];
  }

  return baseMenu; // Default menu if no user type is found
};

const Menu = generateMenu();

export default Menu;